import find from "lodash/find";

import { storefrontClient } from "@/scripts/storefrontClient";
import { handleize } from "@/scripts/utils";
import {
  removeFromWishlist,
  addToWishlist,
  getWishlist,
} from "@/services/wishlist";
import { pushAddToWishlist, pushDataBundleProduct, pushDataAddToCart } from "@/scripts/datalayer";

const handleReplace = (str) => str.replace(/-/g, "_");

const productsQuery = (handles = []) =>
  `fragment productDetails on Product {
    id
    handle
    title
    featuredImage { id }
    descriptionHtml
    onlineStoreUrl
    tags
    variants(first: 1) {
      nodes {
        id
        price { amount }
        availableForSale
      }
    }
  }
  {
    ${handles.map(
      (handle) => `handle_${handleReplace(
        handle
      )}:product(handle: "${handle}") {
      ...productDetails
    }\n`
    )}
  }`;

const productByHandleQuery = (handle) =>
  `{
      product(handle: "${handle}") {
        id
        handle
        title
        featuredImage { id }
        descriptionHtml
        onlineStoreUrl
        vendor
        variants(first: 1) {
          nodes {
            id
            title
            price  {
              amount
              currencyCode
            }
            sku
            availableForSale
          }
        }
      }
  }`;

class ProductFormElement extends HTMLElement {
  constructor() {
    super();

    if (this.dataset.variants) {
      this.variants = JSON.parse(this.dataset.variants);
    }

    this.freeProduct = null;

    this.addToWishlist = this.querySelector(".js-add-to-wishlist");
    this.heartFill = this.querySelector(".heart-fill");
    this.wishlist = window.BARREL.wishlist;
    this.wishlistItem = null;
    const formEl = this.querySelector("form");
    const { isSticky } = this.dataset;

    if (formEl) {
      formEl.addEventListener("change", (event) => {
        if (event.target.closest("[data-option]")) {
          this.onOptionChange(event);
        }
      });

      formEl.addEventListener("submit", (event) => {
        event.preventDefault();
        if (this.freeProduct) {
          const activeVariant = this.freeProduct.variants.nodes.filter(
            (variant) => variant.availableForSale
          )[0];

          fetch(`${window.location.origin}/cart.js`)
          .then(res => res.clone().json().then(data => {

            if (activeVariant !== undefined) {
              const variantId = activeVariant.id
                .split("gid://shopify/ProductVariant/")
                .at(-1);

              const itemIds = data?.items?.map(item => item.id.toString())
              const hasFreeProduct = itemIds.includes(variantId)
              let items = [];

              if (!hasFreeProduct) {
                items.push({
                  id: variantId,
                  quantity: 1,
                });
              }
              let formData = {
                items: items,
                sections: "site-header,cart",
                sections_url: window.location.pathname,
              };
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
              }).then(() => {
                document
                  .querySelector("shopify-cart")
                  .addItemFromForm(event.target);
              });
            } else {
              document
                .querySelector("shopify-cart")
                .addItemFromForm(event.target);
            }
          }))
        } else {
          const bundleItemEls = formEl.parentElement.querySelectorAll(
            ".js-btn-add-to-cart-data-layer"
          );
          let items = [];
          bundleItemEls.forEach((item) => {
            const { handle } = item.dataset;
            items.push({
              item_name: handle,
            });
          });
          document.querySelector("shopify-cart").addItemFromForm(event.target);

          const buttonEl = formEl.querySelector('.js-btn-add-to-cart')
          if (buttonEl) {
            pushDataAddToCart(buttonEl)
          }
        }

        const { isBundle } = this.dataset;
        if (isBundle) {
          const bundleItemEls = formEl.parentElement.querySelectorAll(
            ".js-datalayer-bundle-item"
          );
          let items = [];
          bundleItemEls.forEach((item) => {
            const { title, sku } = item.dataset;
            items.push({
              item_id: sku,
              item_name: title,
              coupon: "",
              discount: "",
              item_bundle: "True",
            });
          });
          if (items.length) pushDataBundleProduct(items);
        }

        if (isSticky && document.querySelector("product-form-sticky")) {
          setTimeout(() => {
            document.querySelector("product-form-sticky").closeForm();
          }, 3000);
        }
      });
    }

    if (this.addToWishlist) {
      this.addToWishlist.addEventListener(
        "click",
        this.addToWishlistClickHandler.bind(this)
      );
    }
    if (this.dataset.bundleComponentProducts) {
      this.loadBundleComponentProducts();
    }

    if (this.dataset.free_gift_sku) {
      this.loadFreeProduct();
    }

    window.document.addEventListener(
      "wishlistLoaded",
      this.handleWishlistLoaded.bind(this)
    );
    const style = `<style>
                        .shopify-installments__learn-more {
                            position: relative;
                            text-underline-offset: 1.5px;
                        }
                        .shopify-installments__learn-more:after {
                            content: '';
                            height: 1px;
                            background: black;
                            position: absolute;
                            bottom: 1px;
                            left: 0;
                            width: 0;
                            z-index: -1;
                        }
                        .shopify-installments__learn-more:hover {
                            text-decoration: none;
                        }
                        .shopify-installments__learn-more:hover:after {
                            transition: width 0.3s linear;
                            width: 100%;
                            z-index: 1;
                        }
                    </style>`;
    setTimeout(() => {
      const paymentTermsEls = document.querySelectorAll(
        "shopify-payment-terms"
      );
      paymentTermsEls.forEach((item) => {
        const learMoreButtonEl = item.shadowRoot.querySelector(
          ".shopify-installments__learn-more"
        );
        if (learMoreButtonEl?.parentElement.querySelector("style") === null) {
          learMoreButtonEl?.insertAdjacentHTML("beforebegin", style);
        }
        item.shadowRoot.querySelector('svg').setAttribute('aria-label', 'Shop Pay')
        item.shadowRoot.querySelector('iframe').setAttribute('aria-hidden', 'true')
      });
    }, 500);
  }

  handleWishlistLoaded({ detail }) {
    this.wishlist = detail.data;
    this.wishlistItem = this.findWishlistItem();
    this.updateHeartFill();
  }

  findWishlistItem() {
    if (!this.wishlist) {
      return;
    }

    const productId = this.dataset.productId;
    return this.wishlist.find(({ product }) => product.id === productId);
  }

  updateHeartFill() {
    if (!this.heartFill || !this.wishlist) {
      return;
    }

    if (!this.wishlistItem) {
      this.heartFill.style.fill = "";
      return;
    }

    this.heartFill.style.fill = "black";
  }

  async addToWishlistClickHandler(event) {
    event.preventDefault();

    const variantId = this.querySelector('[name="id"]')?.value;
    const customerId = window.BARREL.customerId;
    const productId = this.dataset.productId;
    const handle = this.dataset.productHandle;
    const wishListItemId = this.wishlistItem?.wishListItemID;
    const qty = 1;

    if (!customerId) {
      return window.location.replace(window.BARREL.routes.account_login_url);
    }

    try {
      if (!wishListItemId) {
        await addToWishlist({
          customerId,
          productId,
          handle,
          variantId,
          qty,
        });

        const productData = JSON.parse(
          decodeURIComponent(this.dataset.datalayerProduct)
        );
        productData.index = 0;
        productData.item_list_id = handleize(this.dataset.placement);
        productData.item_list_name = this.dataset.placement;

        pushAddToWishlist(productData);
      } else {
        await removeFromWishlist({
          customerId,
          wishListItemId,
        });
      }
      await this.refreshWishlist();
    } catch (error) {
      console.error(error);
    }
  }

  async refreshWishlist() {
    window.BARREL.wishlist = await getWishlist();
    const event = new window.CustomEvent("wishlistLoaded", {
      detail: window.BARREL.wishlist,
    });
    window.document.dispatchEvent(event);
  }

  onOptionChange(event) {
    const formEl = this.querySelector("form");

    const option1 = formEl.querySelector(
      '[data-option="1"] input[type="radio"]:checked'
    );
    const option2 = formEl.querySelector(
      '[data-option="2"] input[type="radio"]:checked'
    );
    const option3 = formEl.querySelector(
      '[data-option="3"] input[type="radio"]:checked'
    );

    const matchingVariant = find(this.variants, {
      option1: option1?.value || null,
      option2: option2?.value || null,
      option3: option3?.value || null,
    });

    this.querySelector('input[name="id"]').value = matchingVariant.id;

    this.dispatchEvent(
      new CustomEvent("change-variant", {
        detail: { id: matchingVariant.id },
        bubbles: true,
      })
    );
  }

  insertDecimalFromLastTwoDigit(number) {
    var numberString = number.toString();
    var modifiedNumberString =
      numberString.slice(0, -2) + "." + numberString.slice(-2);
    var modifiedNumber = parseFloat(modifiedNumberString);
    return modifiedNumber;
  }

  filterComponentTag(tag) {
    const bundleComponents = tag.filter((element) =>
      element.includes("Bundle Components")
    );
    const newArray = bundleComponents.map((element) => element.split("|")[1]);
    return newArray;
  }

  compareTag(arr1, arr2) {
    if (arr1.length != arr2.length) {
      return false;
    }
    return (
      arr1.sort().toString().toLowerCase() ===
      arr2.sort().toString().toLowerCase()
    );
  }

  loadBundleComponentProducts() {
    const handles = this.dataset.bundleComponentProducts.split("|");
    const tag = JSON.parse(this.dataset.productTag);
    const product_handle = this.filterComponentTag(tag);
    let compareFlag = false;
    if (this.compareTag(handles, product_handle)) {
      compareFlag = true;
    }

    const productPrice = this.insertDecimalFromLastTwoDigit(
      this.dataset.productPrice
    );
    var productComponetPrice = 0;

    storefrontClient(productsQuery(handles)).then((response) => {
      if (response.data) {
        let available = true;
        let isNotIncludeTag = false;
        if (compareFlag) {
          isNotIncludeTag =
            Object.values(response.data).filter(
              ({ tags }) => !tags.includes("available:online")
            ).length > 0;
          // Append hidden inputs for bundle component product variants
          Object.keys(response.data).forEach((dataKey) => {
            const variantGid = response.data[dataKey].variants.nodes[0].id;
            productComponetPrice =
              productComponetPrice +
              parseFloat(
                response.data[dataKey].variants.nodes[0].price.amount
              );
            const variantId = variantGid.slice(variantGid.lastIndexOf("/") + 1);
            const input = document.createElement("input");
            input.name = "id[]";
            input.type = "hidden";
            input.value = variantId;
            this.querySelector("form").appendChild(input);

            if (!response.data[dataKey].variants.nodes[0].availableForSale) {
              available = false;
            }
          });

          this.dispatchEvent(
            new CustomEvent("load-bundle-components", {
              detail: response.data,
              bubbles: true,
            })
          );
        }
        if (
          available &&
          productPrice < productComponetPrice &&
          compareFlag &&
          !isNotIncludeTag
        ) {
          // Enable add-to-cart button once bundle component products are present in form
          this.querySelector("[data-bundle-add]").classList.remove("hidden");
          this.querySelector("[data-bundle-add]").disabled = isNotIncludeTag;
          document.querySelector("[data-bundle-recommended-sold-out]")?.classList.add("md:block");
        } else {
          // Show out-of-stock button if bundle components are not available
          this.querySelector("[data-bundle-add]").classList.add("hidden");
          this.querySelector("[data-bundle-sold-out]")?.classList.remove("hidden");
        }
      }
    });
  }

  loadFreeProduct() {
    const handle = this.dataset.free_gift_sku;

    storefrontClient(productByHandleQuery(handle)).then((response) => {
      if (response.data) {
        const { product } = response.data;
        const { title, variants } = product;
        const activeVariant = variants.nodes.filter(
          (variant) => variant.availableForSale
        )[0];
        this.freeProduct = product;
      }
    });
  }
}

if (!customElements.get('product-form')) {
  customElements.define("product-form", ProductFormElement);
}